// Define screen widths for media queries here
export const DISPLAY_WIDTH = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tabletS: 596,
  tabletL: 768,
  tabletG: 850, // g for Giant :)
  laptopS: 1024,
  laptopL: 1200,
  laptopG: 1250,
  desktopS: 1360,
  desktop: 1440,
}

export const DEVICE = {
  mobileS: `screen and (min-width: ${DISPLAY_WIDTH.mobileS}px)`,
  mobileM: `screen and (min-width: ${DISPLAY_WIDTH.mobileM}px)`,
  mobileL: `screen and (min-width: ${DISPLAY_WIDTH.mobileL}px)`,
  tabletS: `screen and (min-width: ${DISPLAY_WIDTH.tabletS}px)`,
  tabletL: `screen and (min-width: ${DISPLAY_WIDTH.tabletL}px)`,
  tabletG: `screen and (min-width: ${DISPLAY_WIDTH.tabletG}px)`,
  laptopS: `screen and (min-width: ${DISPLAY_WIDTH.laptopS}px)`,
  laptopL: `screen and (min-width: ${DISPLAY_WIDTH.laptopL}px)`,
  laptopG: `screen and (min-width: ${DISPLAY_WIDTH.laptopG}px)`,
  desktopS: `screen and (min-width: ${DISPLAY_WIDTH.desktopS}px)`,
  desktop: `screen and (min-width: ${DISPLAY_WIDTH.desktop}px)`,
}

export const BLOCK_MARGIN_TOP = 64

export const NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP = 858
export const NAVIGATION_BAR_COLLAPSED_SIZE = {
  desktop: {
    width: 123,
  },
  mobile: {
    height: 115,
  },
}

export const DROPDOWN_STYLES = {
  control: (
    provided,
    { selectProps: { width = 'unset', marginRight = 'unset', height = '42px' } }
  ) => ({
    ...provided,
    backgroundColor: 'var(--content-background-light)',
    color: 'var(--content-background-dark-blue)',
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 600,
    border: 'none',
    boxShadow: 'none',
    fontSize: '1.4rem',
    paddingLeft: '17px',
    height: height,
    width: width,
    marginRight: marginRight,
  }),
  placeholder: provided => ({
    ...provided,
    color: 'var(--content-background-dark-blue)',
  }),
  indicatorSeparator: () => ({
    // just null this out to get rid of it
  }),
  clearIndicator: provided => ({
    ...provided,
    color: 'var(--content-background-dark-blue)',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    color: 'var(--content-background-dark-blue)',
  }),
  singleValue: provided => ({
    ...provided,
    color: 'var(--content-background-dark-blue)',
  }),
  menuList: provided => ({
    ...provided,
    backgroundColor: 'var(--content-background-light)',
    color: 'var(--content-background-dark-blue)',
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 600,
    fontSize: '1.4rem',
    paddingLeft: '0',
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? 'white' : 'unset',
    backgroundColor: state.isFocused ? 'var(--highlight-blue)' : 'unset',
    paddingLeft: '26px',
    // textDecorationLine: state.isFocused ? 'underline' : 'unset'
  }),
}

export const NAV_MENU_STATUS = {
  OPEN_NAV: 'open page navigation',
  OPEN_SEARCH: 'open search',
  CLOSED: 'closed',
}

// Prismic has a 20 document cap on queries.
export const MAX_ITEMS_PER_PAGINATED_PAGE = 20

// used in Bottom Line / General Site Settings Google Ads query
export const PAGE_TYPE = {
  SUBPAGE: 'SUBPAGE',
  LANDING_PAGE: 'LANDING_PAGE',
  HCP_DETAIL_PAGE: 'HCP_DETAIL_PAGE',
  ADVANCE_ARTICLE: 'ADVANCE_ARTICLE',
  MEDIA_LIBRARY_ITEM: 'MEDIA_LIBRARY_ITEM',
  MEDIA_LIBRARY_LANDING: 'MEDIA_LIBRARY_LANDING',
  PRODUCT_PAGE: 'PRODUCT_PAGE',
  AUDIENCE_PAGE: 'AUDIENCE_PAGE',
  EVENTS_LANDING_PAGE: 'EVENTS_LANDING_PAGE',
}

// Currently used only in EmbeddedForm component
export const FORM_TYPE = {
  CODE_EMBED: 'Code Embed',
  FORM_ASSEMBLY: 'FormAssembly',
  RAISERS_EDGE: "Raiser's Edge",
  CURATOR_IO: 'Curator.io',
  RIDDLE: 'Riddle',
}
